/* tslint:disable */
type InsiderRelationship =
  'Through affiliated company' |
  'Through beneficial interest' |
  'Through child' |
  'Through combined interest' |
  'Through controlled corporation' |
  'Through custodian' |
  'Through deemed interest' |
  'Through discretionary trust' |
  'Through employee trust' |
  'Through family holding' |
  'Through family member' |
  'Through foundation' |
  'Through fund' |
  'Through holding company' |
  'Through indirect interest' |
  'Through investment company' |
  'Through investment manager' |
  'Through joined interest' |
  'Through legal entity' |
  'Through lending agent' |
  'Through other' |
  'Through pension fund' |
  'Through public company' |
  'Through security interest' |
  'Through self-invested personal pension' |
  'Through spouse' |
  'Through subsidiary (partly owned)' |
  'Through subsidiary (wholly owned)' |
  'Through trust' |
  'Through trust as beneficiary' |
  'Through trustee' |
  'Through underwriter';
module InsiderRelationship {
  export const THROUGH_AFFILIATED_COMPANY: InsiderRelationship = 'Through affiliated company';
  export const THROUGH_BENEFICIAL_INTEREST: InsiderRelationship = 'Through beneficial interest';
  export const THROUGH_CHILD: InsiderRelationship = 'Through child';
  export const THROUGH_COMBINED_INTEREST: InsiderRelationship = 'Through combined interest';
  export const THROUGH_CONTROLLED_CORPORATION: InsiderRelationship = 'Through controlled corporation';
  export const THROUGH_CUSTODIAN: InsiderRelationship = 'Through custodian';
  export const THROUGH_DEEMED_INTEREST: InsiderRelationship = 'Through deemed interest';
  export const THROUGH_DISCRETIONARY_TRUST: InsiderRelationship = 'Through discretionary trust';
  export const THROUGH_EMPLOYEE_TRUST: InsiderRelationship = 'Through employee trust';
  export const THROUGH_FAMILY_HOLDING: InsiderRelationship = 'Through family holding';
  export const THROUGH_FAMILY_MEMBER: InsiderRelationship = 'Through family member';
  export const THROUGH_FOUNDATION: InsiderRelationship = 'Through foundation';
  export const THROUGH_FUND: InsiderRelationship = 'Through fund';
  export const THROUGH_HOLDING_COMPANY: InsiderRelationship = 'Through holding company';
  export const THROUGH_INDIRECT_INTEREST: InsiderRelationship = 'Through indirect interest';
  export const THROUGH_INVESTMENT_COMPANY: InsiderRelationship = 'Through investment company';
  export const THROUGH_INVESTMENT_MANAGER: InsiderRelationship = 'Through investment manager';
  export const THROUGH_JOINED_INTEREST: InsiderRelationship = 'Through joined interest';
  export const THROUGH_LEGAL_ENTITY: InsiderRelationship = 'Through legal entity';
  export const THROUGH_LENDING_AGENT: InsiderRelationship = 'Through lending agent';
  export const THROUGH_OTHER: InsiderRelationship = 'Through other';
  export const THROUGH_PENSION_FUND: InsiderRelationship = 'Through pension fund';
  export const THROUGH_PUBLIC_COMPANY: InsiderRelationship = 'Through public company';
  export const THROUGH_SECURITY_INTEREST: InsiderRelationship = 'Through security interest';
  export const THROUGH_SELF_INVESTED_PERSONAL_PENSION: InsiderRelationship = 'Through self-invested personal pension';
  export const THROUGH_SPOUSE: InsiderRelationship = 'Through spouse';
  export const THROUGH_SUBSIDIARY_PARTLY_OWNED_: InsiderRelationship = 'Through subsidiary (partly owned)';
  export const THROUGH_SUBSIDIARY_WHOLLY_OWNED_: InsiderRelationship = 'Through subsidiary (wholly owned)';
  export const THROUGH_TRUST: InsiderRelationship = 'Through trust';
  export const THROUGH_TRUST_AS_BENEFICIARY: InsiderRelationship = 'Through trust as beneficiary';
  export const THROUGH_TRUSTEE: InsiderRelationship = 'Through trustee';
  export const THROUGH_UNDERWRITER: InsiderRelationship = 'Through underwriter';
  export function values(): InsiderRelationship[] {
    return [
      THROUGH_AFFILIATED_COMPANY,
      THROUGH_BENEFICIAL_INTEREST,
      THROUGH_CHILD,
      THROUGH_COMBINED_INTEREST,
      THROUGH_CONTROLLED_CORPORATION,
      THROUGH_CUSTODIAN,
      THROUGH_DEEMED_INTEREST,
      THROUGH_DISCRETIONARY_TRUST,
      THROUGH_EMPLOYEE_TRUST,
      THROUGH_FAMILY_HOLDING,
      THROUGH_FAMILY_MEMBER,
      THROUGH_FOUNDATION,
      THROUGH_FUND,
      THROUGH_HOLDING_COMPANY,
      THROUGH_INDIRECT_INTEREST,
      THROUGH_INVESTMENT_COMPANY,
      THROUGH_INVESTMENT_MANAGER,
      THROUGH_JOINED_INTEREST,
      THROUGH_LEGAL_ENTITY,
      THROUGH_LENDING_AGENT,
      THROUGH_OTHER,
      THROUGH_PENSION_FUND,
      THROUGH_PUBLIC_COMPANY,
      THROUGH_SECURITY_INTEREST,
      THROUGH_SELF_INVESTED_PERSONAL_PENSION,
      THROUGH_SPOUSE,
      THROUGH_SUBSIDIARY_PARTLY_OWNED_,
      THROUGH_SUBSIDIARY_WHOLLY_OWNED_,
      THROUGH_TRUST,
      THROUGH_TRUST_AS_BENEFICIARY,
      THROUGH_TRUSTEE,
      THROUGH_UNDERWRITER
    ];
  }
}

export { InsiderRelationship }